import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.37 3.05',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M3.31,1H.06A.06.06,0,0,1,0,.93V.06A.06.06,0,0,1,.06,0H3.31a.06.06,0,0,1,.06.06V.93A.06.06,0,0,1,3.31,1ZM.12.87H3.24V.12H.12Z"
        />
        <path
          fill={fill}
          d="M3.31,1.85H.06A.06.06,0,0,1,0,1.79V.93A.06.06,0,0,1,.06.87H3.31a.06.06,0,0,1,.06.06v.86A.06.06,0,0,1,3.31,1.85ZM.12,1.73H3.24V1H.12Z"
        />
        <path
          fill={fill}
          d="M3.31,2.72H.06A.06.06,0,0,1,0,2.66V1.79a.06.06,0,0,1,.06-.06H3.31a.06.06,0,0,1,.06.06v.87A.06.06,0,0,1,3.31,2.72ZM.12,2.6H3.24V1.85H.12Z"
        />
        <path
          fill={fill}
          d="M3.12,3.05H.25A.06.06,0,0,1,.19,3V2.66A.06.06,0,0,1,.25,2.6H3.12a.06.06,0,0,1,.06.06V3A.06.06,0,0,1,3.12,3.05ZM.31,2.93H3.06V2.72H.31Z"
        />
        <path
          fill={fill}
          d="M1.68.71A.22.22,0,1,1,1.9.49.22.22,0,0,1,1.68.71Zm0-.31a.09.09,0,0,0-.09.09.09.09,0,0,0,.09.1.09.09,0,0,0,.1-.1A.09.09,0,0,0,1.68.4Z"
        />
        <path
          fill={fill}
          d="M1.68,1.58a.22.22,0,1,1,.22-.22A.22.22,0,0,1,1.68,1.58Zm0-.32a.1.1,0,0,0,0,.2.1.1,0,1,0,0-.2Z"
        />
        <path
          fill={fill}
          d="M1.68,2.45a.22.22,0,0,1-.22-.22.22.22,0,0,1,.44,0A.22.22,0,0,1,1.68,2.45Zm0-.32a.09.09,0,0,0-.09.1.09.09,0,0,0,.09.09.09.09,0,0,0,.1-.09A.09.09,0,0,0,1.68,2.13Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
